@if (user) {
    <hx-application [ngClass]="applicationBackgroundClass()" data-ebp-ta="application">
        <hx-navigation
            data-ebp-ta="navigation"
            [legalNotice]="legalNotice"
            [navItems]="navItems()"
            [hxUser]="{
                firstname: user.given_name,
                lastname: user.family_name,
                email: user.email
            }" />
            <app-informations
                [shineMigrationType]="shineMigrationType"
                [isAuthorized]="isAuthorized"
                [domainId]="domainId"
            />
        <div class="page">
            <router-outlet />
        </div>
    </hx-application>
} @else {
    <div class="spinner-container">
        <hx-spinner [spinning]="true" data-ebp-ta="loader" />
    </div>
}
